module.exports = __webpack_public_path__ + "static/media/plan_pk_2019.e2bbaba6.doc";